import {Box, Chip, Stack, useTheme} from '@mui/material';
import {GROUP_RANGES} from '../FsvFdc/labels';
import {BarLabels} from './BarChart';

interface LegendProps {
    labels?: BarLabels;
    groupNumber?: number | null;
}

const Legend = ({labels, groupNumber}: LegendProps) => {
    const theme = useTheme();

    const groupLabel =
        labels?.group && groupNumber != null ? `${labels.group} (Gruppo ${groupNumber}, ${GROUP_RANGES[groupNumber]})` : labels?.group;

    const items = [
        {label: labels?.uoa ?? 'Il mio progetto', color: theme.palette.primary.main},
        ...(groupLabel ? [{label: groupLabel, color: theme.palette.grey[500]}] : []),
        {label: labels?.average ?? 'Media dei progetti', color: theme.palette.primary.dark},
    ];

    return (
        <Stack direction='row' spacing={1} sx={{mb: 3}}>
            {items.map(({label, color}) => (
                <Chip
                    key={label}
                    size='small'
                    label={label}
                    icon={
                        <Box
                            component='span'
                            sx={{
                                width: 10,
                                height: 10,
                                borderRadius: '2px',
                                bgcolor: color,
                                ml: '6px !important',
                                flexShrink: 0,
                            }}
                        />
                    }
                    variant='outlined'
                    sx={{
                        fontSize: 11,
                        color: 'text.secondary',
                        borderColor: 'divider',
                    }}
                />
            ))}
        </Stack>
    );
};

export default Legend;
